import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=1af0d1cf&"
import script from "./Visit.vue?vue&type=script&lang=ts&"
export * from "./Visit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports